import '../styles/userScreen.css'
import AsyncSelect from "react-select/async"
import Select from 'react-select'
import { useState, useEffect } from 'react'
import {userRegister} from '../services/authServices.js'
import { showUsers } from '../services/userServices.js'
import UserCard from '../components/componentsScreenUsers/userCard.jsx'
import CreateUserPanel from "../components/componentsScreenUsers/createUserPanel.jsx"
import AdminContainer from '../components/AdminContainer.jsx'

export default function UsersScreen() {

    const [usuarios, setUsuarios] = useState([])
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [isOpen, setIsOpen] = useState(false)
    const [count, setCount] = useState(false)

    useEffect(() => {
        const checkUsuarios = async () => {
            const data = await showUsers(page)

            setUsuarios(data.data)
            setTotalPages(data.totalPage)
        }
        checkUsuarios()
    }, [page, count])

    return (
        <AdminContainer rols={['admin']}>
            <div className="user-panel">
            <div className="panel-header">
                <button className="refresh-btn" onClick={() => setIsOpen(!isOpen)}>Crear usuario</button>
            </div>
            {
                isOpen &&(
                    <CreateUserPanel clousePanel={() => setIsOpen(!isOpen)}></CreateUserPanel>
                )
            }
            
            <div>
                <div className="user-list">
                    {usuarios.map((user, index) => (
                        <UserCard key={index} refreshUser={() => setCount(!false)} user={user}></UserCard>
                    ))}
                </div>

                <div className="pagination">
                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            onClick={() => setPage(i + 1)}
                            className={`pagination-btn ${page === i + 1 ? 'active' : ''}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
            </div>
            
        </div>
        </AdminContainer>
        
    )
}